import axios from 'axios';

export const getAPIFetcher = (url: string) => axios.get(url).then((res) => res.data);
export const postAPIFetcher = ({ url, body }) => axios.post(url, body).then((res) => res.data);
